import { Logger } from "@shared/utils/Logger";
import { QontactUser } from "@shared/models/QontactUser";
import { CoreDependencies as SharedCoreDependencies } from "@shared/core/CoreDependencies";
import { HTTPClient } from "@shared/core/HTTPClient";
import { CoreDependencies } from "./CoreDependencies";

export class Application {
    private static instance: Application

    private constructor() {}
    private _coreDependencies: CoreDependencies
    private _sharedCoreDependencies: SharedCoreDependencies
    private _currentOrganizationId: string | null = null
    private _timezone: string = 'America/Argentina/Buenos_Aires'
    private _token: string
    private _currentUser?: QontactUser
    private _onSessionExpired?: () => void

    public static shared(): Application {
        if (!Application.instance) {
            Application.instance = new Application()
        }
        return Application.instance;
    }

    public static setDependencies(
        coreDependencies: CoreDependencies,
        sharedCoreDependencies: SharedCoreDependencies,
    ) {
        Application.shared()._coreDependencies = coreDependencies
        Application.shared()._sharedCoreDependencies = sharedCoreDependencies
        Application.shared().syncAuthenticatedClientHeaders()
    }

    public get coreDependencies(): CoreDependencies {
        return this._coreDependencies
    }

    public get currentOrganizationId(): string | null {
        return this._currentOrganizationId
    }

    public set currentOrganizationId(orgId: string | null) {
        this._currentOrganizationId = orgId
        this.syncAuthenticatedClientHeaders()
    }

    public setToken(token: string) {
        this._token = token
        this.syncAuthenticatedClientHeaders()
    }

    public get timezone(): string {
        return this._timezone
    }

    public set timezone(timezone: string) {
        this._timezone = timezone

        if (typeof window !== "undefined") {
            window.dispatchEvent(new Event("qontact:timezone"))
        }
    }
    
    public handleSessionExpired() {
        Logger.log("Application", "handle session expired")        
        this._onSessionExpired?.()
        // Optionally clear token/user here
        this._token = ''
        this._currentUser = undefined
    }

    private syncAuthenticatedClientHeaders() {
        if (!this._coreDependencies) {
            return
        }

        const httpClient = this._coreDependencies.httpClient as HTTPClient
        httpClient.setClientHeaders({
            ...(httpClient.clientHeaders ?? {}),
            "Content-Type": "application/json",
            "x-access-token": this._token ?? '',
            "x-organization-id": this._currentOrganizationId ?? '',
        })
    }

}
